import { createContext, useContext } from "react";

const FlowContext = createContext(null);

export const FlowProvider = ({ value, children }) => {
  return <FlowContext.Provider value={value}>{children}</FlowContext.Provider>;
};

export const useFlowContext = () => useContext(FlowContext);